import { createTypedStatementHandler } from '../common/createTypedStatementHandler';
import { StructureDslBuilder } from './StructureDslBuilder';
export const createStructureStatementHandler = (args) => {
    return createTypedStatementHandler(args, StructureDslBuilder);
};
//# sourceMappingURL=createStructureStatementHandler.js.map